export default __webpack_public_path__ + "static/media/arena_9.6d303911.jpeg";